import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Link } from "@mui/material";

import { initLocalization } from "../../../utils/helpers";
import { viewMappingDetailsMetadataStrings } from "./locale";

export const ViewMappingDetailsMetadata = ({ item }) => {
  initLocalization(viewMappingDetailsMetadataStrings);

  return (
    <Grid
      container
      flexDirection="column"
      flex="2"
      justifyContent="center"
      gap="0.625rem"
      padding="2rem"
    >
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.socialAccountName}
      </Typography>
      <Typography>{item.name}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.mediaChannel}
      </Typography>
      <Typography>{item.mediaChannelName}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.url}
      </Typography>
      <Link
        href={item.mediaChannelName.length > 0 ? item.accountUrl : ""}
        target="_blank"
      >
        {item.mediaChannelName.length > 0 ? item.accountUrl : ""}
      </Link>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.description}
      </Typography>
      <Typography sx={{ maxHeight: "17rem", overflowY: "auto" }}>
        {item.creativeDetails.creativeText}
      </Typography>
    </Grid>
  );
};

ViewMappingDetailsMetadata.propTypes = {
  item: PropTypes.object.isRequired,
};
